import * as React from 'react';
import {
    ShowBase,
    TextField,
    ReferenceField,
    ReferenceManyField,
    useShowContext,
} from 'react-admin';
import { Box, Card, CardContent, Typography } from '@mui/material';

import { Avatar } from './Avatar';
import { ContactAside } from './ContactAside';
import { NotesIterator } from '../notes';
import { Contact } from '../types';
import { SupplierAvatar } from '../suppliers/SupplierAvatar';

export const ContactShow = () => (
    <ShowBase>
        <ContactShowContent />
    </ShowBase>
);

const ContactShowContent = () => {
    const { record, isPending } = useShowContext<Contact>();
    if (isPending || !record) return null;

    return (
        <Box mt={2} mb={2} display="flex">
            <Box flex="1">
                <Card>
                    <CardContent>
                        <Box display="flex">
                            <Avatar />
                            <Box ml={2} flex="1">
                                <Typography variant="h5">
                                    {record.nome_contato}
                                </Typography>
                                <Typography variant="body2" component="div">
                                    {record.desc_tipo}
                                    {record.desc_tipo &&
                                        record.id_pessoa != null &&
                                        ' na '}
                                    {record.id_pessoa != null && (
                                        <ReferenceField
                                            source="id_pessoa"
                                            reference="persons"
                                            link="show"
                                        >
                                            <TextField source="nome_razao" />
                                        </ReferenceField>
                                    )}
                                </Typography>
                            </Box>
                            <Box>
                                <ReferenceField
                                    source="id_pessoa"
                                    reference="persons"
                                    link="show"
                                    sx={{ '& a': { textDecoration: 'none' } }}
                                >
                                    <SupplierAvatar />
                                </ReferenceField>
                            </Box>
                        </Box>
                        <ReferenceManyField
                            target="id_pessoa"
                            source="id_pessoa"
                            reference="customernotes"
                            sort={{ field: 'data_hora', order: 'DESC' }}
                        >
                            <NotesIterator showStatus reference="suppliercontacts" />
                        </ReferenceManyField>
                    </CardContent>
                </Card>
            </Box>
            <ContactAside />
        </Box>
    );
};
